import * as React from "react";
type Props = {
  className?: string,
};
function SvgSparkle({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Sparkle"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.913 2C15.4328 2 15.0435 2.40439 15.0435 2.90324V3.80647H14.1739C13.6937 3.80647 13.3043 4.21087 13.3043 4.70971C13.3043 5.20855 13.6937 5.61295 14.1739 5.61295H15.0435V6.51618C15.0435 7.01503 15.4328 7.41942 15.913 7.41942C16.3933 7.41942 16.7826 7.01503 16.7826 6.51618V5.61295H17.6522C18.1324 5.61295 18.5217 5.20855 18.5217 4.70971C18.5217 4.21087 18.1324 3.80647 17.6522 3.80647L16.7826 3.80647V2.90324C16.7826 2.40439 16.3933 2 15.913 2ZM19.8261 6.51618C19.4259 6.51618 19.1015 6.85318 19.1015 7.26888V8.02158H18.3768C17.9766 8.02158 17.6522 8.35857 17.6522 8.77428C17.6522 9.18998 17.9766 9.52697 18.3768 9.52697H19.1015V10.2797C19.1015 10.6954 19.4259 11.0324 19.8261 11.0324C20.2263 11.0324 20.5507 10.6954 20.5507 10.2797V9.52697H21.2754C21.6756 9.52697 22 9.18998 22 8.77428C22 8.35857 21.6756 8.02158 21.2754 8.02158H20.5507V7.26888C20.5507 6.85318 20.2263 6.51618 19.8261 6.51618ZM18.6041 12.3668C19.7484 12.8511 19.6634 14.5628 18.4772 14.9222L13.7224 16.3627L11.891 21.1459C11.4549 22.2847 9.90303 22.2847 9.46696 21.1459L7.63549 16.3627L2.93919 14.9399C1.74671 14.5786 1.66937 12.8544 2.82434 12.3795L7.63549 10.4013L9.46511 5.56872C9.89874 4.42337 11.4592 4.42337 11.8928 5.56872L13.7224 10.4013L17.3746 11.8465L18.6041 12.3668ZM12.7295 11.8866L16.7313 13.5493L12.7852 14.7789C12.5314 14.858 12.3261 15.053 12.2277 15.3086L10.6443 19.4203L9.06098 15.3086C8.96256 15.053 8.75731 14.858 8.50348 14.7789L4.55739 13.5493L8.5592 11.8866C8.78015 11.7948 8.95523 11.6129 9.04362 11.3834L10.6443 7.22661L12.2451 11.3834C12.3334 11.6129 12.5085 11.7948 12.7295 11.8866Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgSparkle;
